// extracted by mini-css-extract-plugin
export var childrenContainer = "_bb-0";
export var virtualScrollArea = "_bb-1";